import Icon from '@/componentsDS/Icon/Icon';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { uniqueId } from "lodash";

const MultiLayerSubTable = ({
	groupName,
	entries,
	headers,
	groupItemLabel,
	customGroupHeaderRender,
	utilities,
	rowSize,
	stickyColumns,
	isCollapsed,
	onToggleCollapse
}) => {

	const renderCustomActions = () => {
		if (customGroupHeaderRender) {
			return customGroupHeaderRender(entries, utilities);
		}
		return null;
	};

	const subTableClass = classNames({
		'ds-multi-layer-table__sub-table__td': true,
		'ds-multi-layer-table__sub-table__td--large-row': rowSize === 'large',
		'ds-multi-layer-table__sub-table__td--small-row': rowSize === 'small'
	});

	const collapseClass = classNames({
		'ds-multi-layer-table__group-header--collapsible': true,
		'ds-multi-layer-table__group-header--collapse': isCollapsed
	});

	return (
		<div className="ds-multi-layer-table__tr ds-multi-layer-table__tr--group">
			<div className="ds-multi-layer-table__group-header">
				<div className='ds-multi-layer-table__group-header__left'>
					<div className={collapseClass} onClick={() => onToggleCollapse(groupName)} data-testid={`group-header-${groupName}`}>
						<Icon name="chevron-down" style="solid" size="medium" />
					</div>
					<div className="ds-multi-layer-table__group-header__name">
						{groupName} <span className="ds-multi-layer-table__group-header__sub-name">({entries.length}) {groupItemLabel}</span>
					</div>
				</div>

				{renderCustomActions && (
					<div className={`ds-multi-layer-table__group-header__right ${stickyColumns ? 'ds-multi-layer-table__group-header__right--sticky' : ''}`}>
						<div className="ds-multi-layer-table__group__header__right__content">
							{renderCustomActions()}
						</div>
					</div>
				)}
			</div>

			{!isCollapsed && (
				<div className="ds-multi-layer-table__sub-table">
					{entries.map((item) => (
						<div className="ds-multi-layer-table__sub-table__tr" key={item.id} data-testid="table-row">
							<div className={subTableClass} />

							{headers.map((header, index) => {
								const isSticky = index >= headers.length - stickyColumns;
								const stickyClass = isSticky ? `ds-multi-layer-table__sub-table--sticky-column` : '';

								const id = uniqueId('td-');

								return (
									<div
										className={`${subTableClass} ${stickyClass}`}
										key={id}
										style={{
											flex: `1 1 ${header.width || '150px'}`
										}}
									>
										{header.render ? header.render(item[header.key], item) : item[header.key]}
									</div>
								);
							})}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

MultiLayerSubTable.propTypes = {
	groupName: PropTypes.string.isRequired,
	entries: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
		})
	).isRequired,
	headers: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			width: PropTypes.string,
			render: PropTypes.func,
		})
	).isRequired,
	groupItemLabel: PropTypes.string,
	customGroupHeaderRender: PropTypes.func,
	utilities: PropTypes.object,
	rowSize: PropTypes.oneOf(['large', 'small']),
	stickyColumns: PropTypes.number,
	isCollapsed: PropTypes.bool,
	onToggleCollapse: PropTypes.func.isRequired,
};

export default MultiLayerSubTable;
